import { render, staticRenderFns } from "./prompt-group-cancel.vue?vue&type=template&id=0df76117"
var script = {}
import style0 from "./prompt-group-cancel.vue?vue&type=style&index=0&id=0df76117&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports